import { LOAD_START, LOAD_STOP } from './types';
import { createAction, getActionList } from './action-utils';
import { ApplicationSpinnerState } from 'ts/types/application-spinner.types';

type actionPayload = Partial<Pick<ApplicationSpinnerState, 'label'>>;

const actions = {
  startLoad: (payload: actionPayload) => createAction(LOAD_START, payload),
  stopLoad: (payload: actionPayload) => createAction(LOAD_STOP, payload),
};

export default actions;

const actionList = getActionList(actions);

export type ApplicationSpinnerActionType = typeof actionList[number];
